var map = {
	"./MBudget.svg": 1135,
	"./Mtel.svg": 1094,
	"./Quickline.svg": 1091,
	"./Salt.svg": 1088,
	"./Spusu.svg": 1095,
	"./Swisscom.svg": 1086,
	"./TalkTalk.svg": 1092,
	"./Wingo.svg": 1087,
	"./migros.svg": 1090,
	"./yallo.svg": 1089
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1134;